// TODO: add props
import React from 'react';
import { getContext } from 'common';
import IconButton from 'components/IconButton';
import CloseIcon from '@nokia-csf-uxr/ccfk-assets/CloseIcon';
import Styled from './styles';

/** All other props than `ref` will be provided to the IconButton component. */
const ProgressIndicatorCloseButton = React.forwardRef((props, ref) => getContext(({ RTL }) => (
  <Styled.CloseButton ref={ref} rtl={RTL}>
    <IconButton {...props}>
      <CloseIcon />
    </IconButton>
  </Styled.CloseButton>
)));

ProgressIndicatorCloseButton.displayName = 'ProgressIndicatorCloseButton';

export default ProgressIndicatorCloseButton;
